/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Remove_FileInputs */

const es_feedback_modal_remove_file = /** @type {(inputs: Feedback_Modal_Remove_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click para remover`)
};

const en_feedback_modal_remove_file = /** @type {(inputs: Feedback_Modal_Remove_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to remove`)
};

/**
* | output |
* | --- |
* | "Click to remove" |
*
* @param {Feedback_Modal_Remove_FileInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_remove_file = /** @type {((inputs?: Feedback_Modal_Remove_FileInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Remove_FileInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_remove_file(inputs)
	return en_feedback_modal_remove_file(inputs)
});
export { feedback_modal_remove_file as "feedback.modal.remove_file" }